import { useEffect, useState, useCallback } from "react";
import { Search, X, Store, Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Modal } from "@/components/Modal";
import { fmtDate } from "@/lib/format";

export function CustomerPickerDialog({ open, onClose, onSelect }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (query) => {
    setLoading(true);
    try {
      const r = await api.get(`/customers`, { params: { q: query || undefined, page: 1, page_size: 20, sort: "name" } });
      setRows(r.data.data);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => load(q), 250);
    return () => clearTimeout(t);
  }, [q, open, load]);

  useEffect(() => { if (open) { setQ(""); load(""); } }, [open, load]);

  return (
    <Modal open={open} onClose={onClose} className="customer-picker-dialog"
      title="Pilih Customer" subtitle="Cari berdasarkan nama toko" testId="customer-picker-dialog">
      <div className="customer-picker-search">
        <Search />
        <input data-testid="customer-picker-search" autoFocus value={q}
          onChange={(e) => setQ(e.target.value)} placeholder="Ketik nama customer…" />
        {q && <button onClick={() => setQ("")} aria-label="Bersihkan"><X /></button>}
      </div>
      <p className="customer-picker-meta">{loading ? "Mencari…" : `${rows.length} customer ditemukan`}</p>
      <div className="customer-picker-list">
        {loading ? (
          <div className="customer-picker-empty"><Loader2 className="spin" /> Memuat…</div>
        ) : rows.length === 0 ? (
          <div className="customer-picker-empty"><Store /> Tidak ada customer</div>
        ) : rows.map((c) => (
          <button key={c.odoo_customer_id} onClick={() => { onSelect(c); onClose(); }}
            data-testid={`customer-option-${c.odoo_customer_id}`}>
            <span className="customer-picker-icon"><Store /></span>
            <span>
              <strong>{c.name}</strong>
              <small>{c.customer_type} · {c.area} · order terakhir {c.last_order_at ? fmtDate(c.last_order_at) : "-"}</small>
            </span>
            <Check />
          </button>
        ))}
      </div>
    </Modal>
  );
}
